module.exports = __webpack_public_path__ + "static/img2_ats-d281878e331b0af1cea89db54c109b98.png";